module.exports = __webpack_public_path__ + "img/epoca-cosmeticos-cover.7799d5f0.jpg";